import ChallengesHeader from "@/challenges/ChallengesFolder/ChallengesHeader";
import ChallengesListSectionContainer from "@/challenges/ChallengesFolder/ChallengesListSectionContainer";
import { Challenge } from "@/challenges/utils/interfaces";
import {
  folderContentsHeader,
  folderContentsWrapper,
} from "./FolderContents.style";

interface FolderContentsProps {
  challenge: Challenge;
  isHomeVersion?: boolean;
}

const FolderContents = ({ challenge, isHomeVersion }: FolderContentsProps) => {
  const { subject, topics } = challenge;
  const isTeacherChallengePage = false;

  const handleTitle = () => {
    switch (subject) {
      case "Science":
        return "Take a look around";
      case "SEL":
        return "Learn something new";
      case "Social Studies":
        return "Dig in deeper";
      default:
        return "Choose your adventure";
    }
  };

  return (
    <div css={folderContentsWrapper}>
      <div css={folderContentsHeader(isTeacherChallengePage)}>
        <ChallengesHeader
          heading={handleTitle()}
          isHomeVersion={isHomeVersion}
        />
      </div>
      <ChallengesListSectionContainer
        isHomeVersion={isHomeVersion}
        topics={topics}
      />
    </div>
  );
};

export default FolderContents;
